import useReveal from "../lib/useReveal";

/**
 * Wraps any block so it fades + slides up gently when scrolled into view.
 * Use on the *inner* container of a <section> so backgrounds and borders
 * are not affected. Runs once per element.
 *
 * <section>
 *   <Reveal className="max-w-[1400px] mx-auto py-20">…</Reveal>
 * </section>
 */
export default function Reveal({ as: Tag = "div", className = "", children, ...rest }) {
  const ref = useReveal();
  return (
    <Tag ref={ref} className={`pg-reveal ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
}
